/**
 * The Outclose mark: a ring opened at the top-right with a seat set just
 * outside it — "out of the closet, at the table". Drawn rather than imported so
 * it inherits the brand gradient and stays crisp at any size.
 */
export default function BrandMark({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="ocmark" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F89D7A" />
          <stop offset="0.45" stopColor="#EF6225" />
          <stop offset="1" stopColor="#81358A" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#ocmark)" />
      <path
        d="M16 8.4a7.6 7.6 0 1 0 6.9 4.4"
        stroke="white"
        strokeWidth="2.6"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="23.4" cy="8.9" r="2.5" fill="white" />
    </svg>
  );
}
